module.exports = __webpack_public_path__ + "img/r-cb1.2f92beb4.gif";